module.exports = __webpack_public_path__ + "img/molde-fk.613faef3.png";